import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`My own Apps & Products`}</h2>
    <ProjectCard title="Evenz" link="https://www.facebook.com/evenzbarlasdev" bg="linear-gradient(to right, #7117ea 0%, #ea6060 100%)" mdxType="ProjectCard">
      {{
        description: "A mobile platform that allows users to create social media pictures for the events they love.",
        logo: props.logos.edges[0]
      }}
    </ProjectCard>
    <ProjectCard title="Dorch" link="https://play.google.com/store/apps/details?id=com.hashed.apps.dorch" bg="linear-gradient(to right, #184e68 0%, #57ca85 100%)" mdxType="ProjectCard">
      {{
        description: "Dorch is a simple Torch app for devices having both front and back flash. This app has crossed 125k downloads on Play Store.",
        logo: props.logos.edges[1]
      }}
    </ProjectCard>
    <ProjectCard title="Feels" link="https://play.google.com/store/apps/details?id=com.meethashirb.feels" bg="linear-gradient(to right, #65799b 0%, #5e2563 100%)" mdxType="ProjectCard">
      {{
        description: "Show the world how your feel today and see how the world is feeling today!",
        logo: props.logos.edges[2]
      }}
    </ProjectCard>
    <ProjectCard title="Vise" link="https://play.google.com/store/apps/details?id=com.meethashirb.vise" bg="linear-gradient(to right, #622774 0%, #c53364 100%)" mdxType="ProjectCard">
      {{
        description: "Share and get an advice from someone anonymously from around the globe.",
        logo: props.logos.edges[3]
      }}
    </ProjectCard>
    <ProjectCard title="MomentShare" link="https://play.google.com/store/apps/details?id=com.meethashirb.moment_share" bg="linear-gradient(to right, #F5515F 0%, #A1051D 100%)" mdxType="ProjectCard">
      {{
        description: "Share a moment and see moments anonymously shared by the people around the globe.",
        logo: props.logos.edges[4]
      }}
    </ProjectCard>
    <h2>{`Some great client projects`}</h2>
    <ProjectCard title="FaceScope" link="https://play.google.com/store/apps/details?id=com.division.patrol.homeland.facescope" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
      {{
        description: "A facial recognition based criminal indexing and records maintainence mobile application platform for security agencies.",
        logo: props.logos.edges[5]
      }}
    </ProjectCard>
    <ProjectCard title="SecureX" link="https://play.google.com/store/apps/details?id=com.division.patrol.homeland.securex" bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
      {{
        description: "A mobile application platform allowing communication between property owners and agents of local private security agencies.",
        logo: props.logos.edges[6]
      }}
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      